var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.props.sortable)?_c('span',{class:this.props.class.replace('float-right', 'sort-icon')}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }